import { InputActionMeta, OnChangeValue } from 'react-select/dist/declarations/src/types';
import { useCallback, useState } from 'react';
import { debounce } from 'lodash';
import { useTranslation } from 'react-i18next';

import {
  AutoCompleteInput,
  AutoCompleteInputOption
} from 'components/AutoCompleteInput/AutoCompleteInput';
import { Bank } from 'models/Bank';
import { SearchBanks, SelectBank } from 'components/HomePage/types';

import { getAutoCompleteBanksOptions } from 'utils/bankAutoComplete';

interface BankAutoCompleteProps {
  banks: Bank[];
  onInputChange: SearchBanks;
  onBankSelect: SelectBank;
}

const ON_INPUT_CHANGE_DEBOUNCE_TIMEOUT = 300; // milliseconds

export const BankAutoComplete = ({ banks, onInputChange, onBankSelect }: BankAutoCompleteProps) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState('');

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedOnInputChange = useCallback(
    debounce(onInputChange, ON_INPUT_CHANGE_DEBOUNCE_TIMEOUT),
    []
  );

  const _onInputChange = (inputValue: string, action: InputActionMeta) => {
    if (action.action === 'input-change') {
      setInputValue(inputValue);
      debouncedOnInputChange(inputValue);
    }
  };

  const onOptionChange = (selectedOption: OnChangeValue<AutoCompleteInputOption, false>) => {
    if (selectedOption) {
      setInputValue(`${selectedOption.label} ${selectedOption.subLabel}`);
      onBankSelect(selectedOption.value);
    }
  };

  return (
    <AutoCompleteInput
      label={t('login_form.old_bank.old_bank_label')}
      id="oldBank.typeahead"
      name="oldBank.typeahead"
      inputValue={inputValue}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      onChange={onOptionChange}
      onInputChange={_onInputChange}
      options={getAutoCompleteBanksOptions(banks)}
    />
  );
};
